import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentFlowButtonComponent } from 'app/modules/shared/document-flow-button/document-flow-button.component';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Actions Cell Renderer Component
 *
 * Reusable cell renderer for displaying action menu with DocumentFlowButton.
 * Shows a menu button that triggers a dropdown containing the document flow component.
 *
 * Usage in ColDef:
 * ```typescript
 * {
 *   colId: 'actions',
 *   cellRenderer: ActionsCellRendererComponent
 * }
 * ```
 */
@Component({
  selector: 'app-actions-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    DocumentFlowButtonComponent
  ],
  template: `
    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
      <app-document-flow-button [element]="element"></app-document-flow-button>
    </mat-menu>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsCellRendererComponent implements CellRenderer<OrderDetailAttributes, any> {
  /**
   * Parameters from the grid containing the cell value and row data
   */
  @Input() params!: CellRendererParams<OrderDetailAttributes, any>;

  /**
   * Get the full row data (element)
   */
  get element(): OrderDetailAttributes {
    return this.params?.data;
  }
}
